// tslint:disable file-name-casing
import i18next from 'i18next';
import * as ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import enTranslations from 'data/translations/en';
import frTranslations from 'data/translations/fr';

i18next
    .use(initReactI18next)
    .use(ICU)
    .init({
        fallbackLng: 'en',
        resources: {...{ en: enTranslations }, ...{ fr: frTranslations }},
        ns: ['common'],
        defaultNS: 'common',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        nsSeparator: '.',
        parseMissingKeyHandler: (key: string) => {
            // todo :: currently strips the missing namespace only
            // if you are debugging, then add a wrapper for <span color="red"> or something similar
            const replacedKey = key.replace(/^([a-z]+[A-z]+\.)+/, '');
            return Env.TRANSLATION_KEYS_ENABLED === 'yes' ? key : replacedKey;
        },
    })
;
const i18n = i18next;

export default i18n;
